module.exports = __webpack_public_path__ + "img/kausima_image2.77f56728.png";